import React from 'react';

export function onLove() {
    return (
        <div>
            <div className="para">
                Forgive my overuse of chaos theory analogies, but everyday human interactions closely resemble two
                stable automata colliding. Brief interactions usually don’t result in any significant behavioural
                restructuring, and it gets even better if the interactions are passive, observing automata or systems of
                automata from a distance and fitting them into your own not only extend one’s mental model of the entity
                but also actively enhance the interpretation mechanisms, of course, this has to be played out in the
                real world to fine tune the model.
            </div>
            <div className="para">
                Being in love leaves no time for one to restructure. You accept whole chunks of your partner with little
                thought going into how those chunks actively reshape your worldview and with absolutely no concern for
                what is to come when the bond cleaves
            </div>
        </div>
    )
}